import { Pedido } from '@/models/pedido'
import { BaseAPI } from '@/api/base.api'
import { Company } from '@/models/company';

export class CompanyAPI extends BaseAPI<Company> {
  constructor() {
    super();
    this.backUrl = `${this.backUrl}/companies`;
  }
}
